import {LoanApplicationWithCheckBoxTableHeaders, LoanApplicationTableHeaders} from "../constants/loan-application-labels";

export const getLoanApplicationTableHeaders = (isReassignLoanApplicationAllowed: boolean) => 
  isReassignLoanApplicationAllowed
    ? Object.values(LoanApplicationWithCheckBoxTableHeaders)
    : Object.values(LoanApplicationTableHeaders);